import { render, staticRenderFns } from "./RecruitingStats.vue?vue&type=template&id=c40ad654&scoped=true&"
import script from "./RecruitingStats.vue?vue&type=script&lang=js&"
export * from "./RecruitingStats.vue?vue&type=script&lang=js&"
import style0 from "./RecruitingStats.vue?vue&type=style&index=0&id=c40ad654&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40ad654",
  null
  
)

export default component.exports